import "./Electronics.css"
import Product1 from "../Components/Product1"

import Electronics1 from "../images/ei1.jpg"
import Electronics2 from "../images/ei2.jpg"
import Electronics3 from "../images/ei3.jpg"
import Electronics4 from "../images/ei4.jpg"
import Electronics5 from "../images/ei5.jpg"
import Electronics6 from "../images/EI6.jpg"
import Electronics7 from "../images/EI7.jpg"
import Electronics8 from "../images/EI8.jpg"
import Electronics9 from "../images/projectadd.jpg"




export default function Electronics() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Electronics9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1   id="elec1" prdName="ARDUINO" img={Electronics1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="elec2"  prdName="ARDUINO_UNO" img={Electronics2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="elec3"  prdName="ULTRASONIC_SENSORR" img={Electronics3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="elec4"  prdName="RELAY" img={Electronics4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="elec5" prdName="GSM_MODULE" img={Electronics5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="elec6" prdName="GPS-MODULE" img={Electronics6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="elec7"  prdName="MOTION_SENSOR" img={Electronics7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="elec8" prdName="JUMPER_WIRES" img={Electronics8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}